angular.module('acme.view.application.importExport.jobExecution.directives.importExportJobExecutionFileUpload', [
  'acme.common.directive.fileInput'
])
.directive('jobExecutionFileUpload', jobExecutionFileUpload)
.controller('ImportExportJobExecutionFileUploadController', ImportExportJobExecutionFileUploadController);

function jobExecutionFileUpload() {
  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'views/application/views/importExport/importExportJobExecution/directives/importExportJobExecutionFileUpload.tpl.html',
    controller: 'ImportExportJobExecutionFileUploadController',
    controllerAs: '$ctrl',
    scope: {},
    bindToController: {
      jobExecutionId: '<',
      tableKey: '=',
      onUploadComplete: '&'
    }
  };
}

/**
 * Controller responsible for handling the ability to upload files to a Job Execution
 * @class {ImportExportJobExecutionFileUploadController}
 * @constructor
 * @return ImportExportJobExecutionFileUploadController} - Class instance
 */
function ImportExportJobExecutionFileUploadController($window, ImportJobExecutionsApiService) {
  Object.assign(this, {
    $window: $window,
    ImportJobExecutionsApiService: ImportJobExecutionsApiService
  });
}

ImportExportJobExecutionFileUploadController.prototype.$onInit = function () {
  this.vm = this._getVm(this);
};

ImportExportJobExecutionFileUploadController.prototype._getVm = function (initialData) {
  var _data = initialData || {},
    jobExecutionId = _data.jobExecutionId || null,
    tableKey = _data.tableKey || null,
    files = [],
    isUploading = _data.isUploading || false;

  return {
    jobExecutionId: jobExecutionId,
    tableKey: tableKey,
    files: files,
    isUploading: isUploading
  };
};

ImportExportJobExecutionFileUploadController.prototype.uploadFile = function () {
  var self = this;
  this.vm.isUploading = true;

  self.ImportJobExecutionsApiService.presign(this.vm.jobExecutionId, self.vm.files[0].name)
    .then(function(response) {
      var url = response.data;

      self.ImportJobExecutionsApiService.uploadCsv(url, self.vm.files[0])
        .then(function() {
          self.vm.isUploading = false;
          self.onUploadComplete({ $filename: self.vm.files[0].name });
        })
        .catch(function(resp) {
          self.vm.isUploading = false;
          self.$window.alert("An error occurred uploading your file, please try again or contact ACME support");
        });
    })
    .catch(function(resp) {
      self.vm.isUploading = false;
      self.$window.alert('An error occurred uploading your file, please try again or contact ACME support');
    });
};

ImportExportJobExecutionFileUploadController.$inject = ['$window', 'ImportJobExecutionsApiService'];
